import { localStorageKeys } from '@/shared/utils/constants';

export const LEGACY_MIGRATION_MARKER = 'legacy-migration-version';

export const LEGACY_MIGRATION_VERSION = '1';

export const LEGACY_SHARED_KEYS = [
  localStorageKeys.spellChecker,
  'composeCommunication-email-body-editor-height',
  'homeownerAssociationFinancePinnedActions',
  'homeownerAssociationPinnedBudgetSections',
  'homeownerAssociationPinnedBuildingsSections',
  'homeownerAssociationPinnedDebtorsSections',
  'homeownerAssociationPinnedDirectDebitSections',
  'homeownerAssociationPinnedDocumentsSections',
  'homeownerAssociationPinnedMeetingsSections',
  'homeownerAssociationPinnedMeterReadingsSections',
  'homeownerAssociationPinnedPaymentsSections',
  'homeownerAssociationPinnedProvisionsSections',
  'homeownerAssociationPinnedSettingsSections',
  'homeownerAssociationPinnedSyndicManagementSections',
  'homeownerAssociationPinnedTabs',
];

export const LEGACY_KEYS = [
  `${localStorageKeys.acceptedInboundHoaInvoices.SHOW_FILTERS}-value`,
  localStorageKeys.acceptedInboundHoaInvoices.SORT_SETTINGS,
  localStorageKeys.acceptedInboundHoaInvoicesPerHoa.SORT_SETTINGS,
  localStorageKeys.accounting.bookings.SORT_SETTINGS,
  localStorageKeys.accounting.reconciliations.supplierOverview.SORT_SETTINGS,
  localStorageKeys.batchCommunicationConfig.COMBINED_SORT_SETTINGS,
  localStorageKeys.batchCommunicationConfig.SORT_SETTINGS,
  localStorageKeys.bookYear.SELECTOR,
  localStorageKeys.cases.DETAIL_PANES,
  localStorageKeys.inboundHoaInvoicesDefault.PANES,
  localStorageKeys.inboundHoaInvoicesDefault.PDF_ZOOM,
  localStorageKeys.recentBuildings,
  localStorageKeys.recentCases,
  localStorageKeys.spreadsheets.PANES,
  'invoiceSortSettings',
];

export const LEGACY_SUFFIXED_KEYS = [
  localStorageKeys.inboundHoaInvoicesDefault.SHOW_FILTERS,
  localStorageKeys.inboundRepairInvoices.SHOW_FILTERS,
  localStorageKeys.inboundRepairInvoices.SORT_SETTINGS,
];
